import classNames from 'classnames';
import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import './style.css';

type IProps = {
  children: ReactNode;
  level?: 'link' | 'label' | 'list';
  color?:
    | 'purple'
    | 'gray'
    | 'blue'
    | 'yellow'
    | 'pink'
    | 'teal'
    | 'black'
    | 'white'
    | 'success'
    | 'error';
  className?: string;
  style?: React.CSSProperties;
};

const NavigationType = ({
  children,
  level = 'link',
  color = 'black',
  className,
  ...props
}: IProps): ReactElement => {
  const textClasses = classNames('navigation-type', {
    [`navigation-type--${level}`]: level,
    [`text-type-${color}`]: color,
    [`${className}`]: className,
  });

  let navigationEl;

  switch (level) {
    case 'list':
    case 'link': {
      navigationEl = (
        <a className={textClasses} {...props}>
          {children}
        </a>
      );
      break;
    }
    default:
      navigationEl = (
        <p className={textClasses} {...props}>
          {children}
        </p>
      );
  }

  return navigationEl;
};

export default NavigationType;
